import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BoxV2 } from '@labrav/react-components'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export type SubscriptionSectionWrapperProps = {
  heading: string
  children: React.ReactElement
  icon?: IconProp
  secondaryActions?: React.ReactElement
}

export const SubscriptionSectionWrapper = ({
  heading,
  children,
  icon,
  secondaryActions,
}: SubscriptionSectionWrapperProps) => {
  return (
    <BoxV2
      heading={heading}
      {...(secondaryActions ? { secondaryActions } : {})}
      {...(icon
        ? {
            headingIcon: (
              <FontAwesomeIcon
                icon={icon}
                style={{ width: '18px', height: '14px' }}
              />
            ),
          }
        : {})}
    >
      {children}
    </BoxV2>
  )
}
